import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styles from '../styles/styles.css';

/* 置顶 */
class Stick extends PureComponent {
    static propTypes = {
        item: PropTypes.object,
        url: PropTypes.string,
    };

    static defaultProps = {
        isDisplaySource: true,
        isCount: true,
        isNewsTime: true,
        isFormatTime: true,
        isClickListItem: false,
    };

    render() {
        const { url, item } = this.props;
        const { title } = item;

        return (
            <section className={styles.stick}>
                <a className={styles.stickLink} href={url}>
                    <span className={styles.stickMark} />
                    <h2 className={styles.stickTitle}>{title}</h2>
                </a>
            </section>
        );
    }
}

export default Stick;
